import React from 'react';

const TwoColumnContent = ({ textContent, media, firstRow = false, mediaFirst = false }) => {
  const textDiv = (
    <div className={`text${firstRow ? ' first-row' : ''}`}>
      {textContent}
    </div>
  );

  return (
    <div className="two-column-content">
      {mediaFirst ? (
        <>
          {media}
          {textDiv}
        </>
      ) : (
        <>
          {textDiv}
          {media}
        </>
      )}
    </div>
  );
};

export default TwoColumnContent;
